export default __webpack_public_path__ + "static/media/repayment.37013c1b.svg";